<template>
  <div>
    <div
      class="md-layout md-alignment-center-space-between tabs-items"
      style=""
      v-if="!isLoadingTabList"
    >
      <div class="md-layout-item " v-for="(tab, index) in tabs" :key="index">
        <!--md-button
          class="md-block"
          md-sm
          :class="isActiveTab(index) ? 'md-success' : 'md-simple border-show'"
          @click="switchPanel(index)"
        >
          {{ $t(tab.name) }}
        </md-button-->
        <div
          class="md-block tab-item md-simple "
          md-sm
          :class="{'tab-active': isActiveTab(index)}"
          @click="switchPanel(index)"
        >
          {{ $t(tab.name).toUpperCase() }}
        </div>
      </div>
    </div>
    <transition name="fade1">
      <template v-if="!isLoadingTabData">
        <DashboardPanel></DashboardPanel>
      </template>
    </transition>
  </div>
</template>

<script>
import {DashboardPanel} from '@/components'

export default {
  components: {
    DashboardPanel
  },
  data() {
    return {
      tabs: [],
      isLoadingTabList: true,
      isLoadingTabData: true,
      activeTab: 0,
      isNextTabPosition: true
    }
  },
  async created() {
    const {tab = 0} = this.$route.query
    this.isLoadingTabList = true
    try {
      const tabs = await this.$store.dispatch('LOAD_DASHBOARD_TABS')
      this.tabs = [...tabs]
      this.switchPanel(+tab)
    } catch (err) {
    } finally {
      this.isLoadingTabList = false
    }
  },
  methods: {
    isActiveTab(tab) {
      return this.activeTab === tab
    },
    async switchPanel(ind) {
      this.$router.replace({name: 'Dashboard', query: {tab: ind}})
      this.isNextTabPosition = this.activeTab < ind
      this.activeTab = ind

      this.isLoadingTabData = true
      try {
        await this.$store.dispatch('LOAD_DASHBOARD_TAB_DATA', this.tabs[ind].id)
      } catch (err) {
        console.error(err)
      } finally {
        this.isLoadingTabData = false
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/md/_variables.scss';
.tab-item {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 60px;
  font-weight: 400;
}
.tab-active {
  color: $brand-success;
  border-bottom: 2px solid $brand-success;
  font-weight: 500;
}
.tabs-items {
  margin-bottom: 20px;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
}
.border-show {
  //border: 1px solid #dddddd;
}

.fade-enter-active {
  transition: all 0.9s ease;
}
.fade-leave-active {
  transition: all 0.9s ease; // cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter {
  //opacity: 0;
}

.fade-enter-from-left {
  transform: translateX(100%);
}
.fade-enter-from-right {
  transform: translateX(-100%);
}
.fade-leave-to {
  opacity: 0;
}
</style>
